module.exports = __webpack_public_path__ + "img/toothpaste-townie.762efdbf.png";